import { __exports as o } from "./index753.mjs";
import { d as p } from "./index795.mjs";
import { f as a } from "./index773.mjs";
import "./index797.mjs";
import { c as i } from "./index808.mjs";
import { t as s } from "./index809.mjs";
import { t as m } from "./index810.mjs";
import { h as c } from "./index811.mjs";
import { i as f } from "./index812.mjs";
import { __exports as n } from "./index800.mjs";
var y = p, D = a, v = n, d = i, l = s, u = m, b = c, I = f, e = Object.getOwnPropertyDescriptor;
o.f = y ? e : function(r, t) {
  if (r = l(r), t = u(t), I)
    try {
      return e(r, t);
    } catch {
    }
  if (b(r, t))
    return d(!D(v.f, r, t), r[t]);
};
export {
  o as default
};
